import { Container, Row, Col } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import Icons from "../../Constants/Icons";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import ScrollAnimation from "react-animate-on-scroll";
import "animate.css/animate.min.css";

export const HomeTwoSection = () => {
  const sectors = [
    {
      title: "Energy & Commodities",
      icon: Icons.Ic_oiltankers,
      description: "Access to leading global refineries and top-tier wholesaler"
    },
    {
      title: "Capital & Transactions",
      icon: Icons.Ic_financial,
      description: "$500M+ real estate assets under management"
    },
    {
      title: "Transactions",
      icon: Icons.Ic_Transactions,
      description: "Hundreds of billions facilitated in lending, M&A & financial structures"
    },
    {
      title: "Technology & Innovation",
      icon: Icons.Ic_futuristic,
      description: "Driving digital transformation & market-shaping innovations"
    },
  ];

  return (
    <section className="feature-boxes"
      style={{
        backgroundImage: `linear-gradient(rgba(19, 18, 18, 0.42), rgba(12, 12, 12, 0.57)), url(${Icons.Ic_lionOne})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover"
      }}
    >
      <Container>
        <Row style={{ width: "100%" }}>
          {sectors.map((sector, idx) => (
            <Col lg={3} key={idx} className=" new-feature">
              <ScrollAnimation animateIn="fadeIn fadeInTop">
                <div className="feature-white">
                  <div className="zoom-animation-imags">
                    <img
                      src={sector.icon}
                      style={{
                        width: "100%",
                        objectFit: "cover",
                      }}
                      alt={sector.title}
                    />
                  </div>
                  <div className="feature-in">
                    <h3 className="text-uppercase fw-bold mt-3">{sector.title}</h3>
                    <p className="text-muted small">{sector.description}</p>
                  </div>
                </div>
              </ScrollAnimation>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export const LionSection = () => {
  return (
    <div className="VideoNewsSection  about-section lion-section">
      <video
        src={Icons.Ic_provide}
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      >
        Your browser does not support the video tag.
      </video>
      <div className="">
        <p >
          We provide direct access to influential decision makers — royal
          families, sovereign entities, multinationals, and top executives —
          with confidentiality and efficiency.
        </p>
      </div>
    </div>
  );
};

export const LatestProducts = () => {
  const services = [
    {
      id: "energy",
      title: "Energy & Commodities",
      description: "We facilitate oil trading  with direct access to major vendors and refineries — no intermediaries. Our network extends into precious metals and strategic commodities, serving the needs of sovereign funds, corporations, and select partners.",
      icon: Icons.Ic_oiltanker,
      direction: "services-left",
    },
    {
      id: "capital",
      title: "Capital & Transactions",
      description: "Advisory on mergers & acquisitions, structured financing, and global investment opportunities. We connect capital to projects and projects to capital, operating at the highest levels of discretion. With over 80 years of experience we have worked with the worlds largest banks.",
      icon: Icons.Ic_investment,
      direction: "services-end"
    },
    {
      id: "Technology",
      title: "Technology & Innovation",
      description: "Development of custom applications, digital platforms, and scalable software solutions. We invest in and advise ventures positioned to transform industries.",
      icon: Icons.Ic_bitcoin,
      direction: "services-left",
      url: "https://www.doctorpocket.ca/"
    },
    {
      id: "hospitality",
      title: "Hospitality & Real Estate",
      description: "Advisory and management of property, hotels, and resorts. We reposition assets to unlock long-term value across global destinations.",
      icon: Icons.Ic_time,
      direction: "services-end",
      url: " https://kozestays.com/"
    },
    {
      id: "brokerage",
      title: "Private Brokerage",
      description: "We broker strategic deals that require access, influence, and precision — connecting parties across industries where relationships matter most.",
      icon: Icons.Ic_location,
      direction: "services-left"
    },
  ];

  return (
    <section style={{
      // backgroundImage: ` url(${Icons.Ic_sectors})`,
      backgroundRepeat: "no-repeat",
      backgroundSize: "cover",
      backgroundAttachment: "fixed"
    }}
      className="py-5 text-center product-section">
      <img src={Icons.Ic_sectors} alt="" className="img-section" />
      <div className="container" style={{ display: "block" }}>
        {services.map((s, idx) => (
          <div key={s.id} className={`${s.direction}`}>
            <div className="product-section-flex">
              <div className="product-imags-section">
                <div className="zoom-animation-imags">

                  <img
                    src={s.icon}
                    alt=""
                    style={{
                      width: "100%",
                      height: "200px",
                      objectFit: "cover",
                    }}
                  />

                </div>
              </div>
              <div className="product-contant-section">
                <div className="product-border" style={{ textAlign: "left" }}>
                  <div>
                    <ScrollAnimation animateIn="fadeIn fadeInLeft">

                      <h3 className="mt-6 text-xl md:text-2xl font-semibold capitalize">
                        {s.title}
                      </h3>
                    </ScrollAnimation >
                    <ScrollAnimation animateIn="fadeIn fadeInTop">
                      <p>{s.description}</p>
                    </ScrollAnimation >
                    {s.url && (
                      <button
                        type="button" 
                        className="golad-button"
                        onClick={() => window.open(s.url, "_blank", "noopener,noreferrer")}
                        style={{
                          padding: "6px 12px",
                          borderRadius: "4px",
                          border: "none",
                          backgroundColor: "black",
                          color: "#fff",
                          cursor: "pointer",
                          "&:hover": {
                            backgroundColor: "white",
                            color: "black",
                          },
                        }}
                      >
                        Read More
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="absolute inset-0 pointer-events-none rounded-2xl ring-1 ring-inset ring-white/10" />
          </div>
        ))}
      </div>
    </section >
  );
};


export const VideoNewsSection = () => {
  return (
    <div className="VideoNewsSection  about-section">
      <video
        src={Icons.SK}
        autoPlay
        muted
        loop
        playsInline
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      >
        Your browser does not support the video tag.
      </video>
      <div className="about-text">
        <ScrollAnimation animateIn="fadeIn fadeInTop">
          <p className="text-white text-2xl md:text-3xl font-light leading-relaxed">
            We bridge capital, opportunity, and leadership — ensuring our partners gain privileged access and reliable execution in complex, high-stakes environments.
          </p>
        </ScrollAnimation>
      </div>
    </div>
  );
};
